import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { userSelector } from 'selectors/user/userSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import userUtils from 'utils/User';
import { bottomNavHiddenSelector } from 'selectors/page/product/bottomNavHidden/bottomNavHiddenSelector';
import { showDynamicBottomNavSelector } from 'viewModel/selectors/testTarget/showDynamicBottomNavSelector';

const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('components/Header/locales', 'Header');

import { isShopYourStoreEnabledSelector } from 'viewModel/selectors/shopYourStore/isShopYourStoreEnabledSelector';

export default connect(
    createSelector(
        userSelector,
        createStructuredSelector({
            tooltip: getTextFromResource(getText, 'tooltip'),
            shop: getTextFromResource(getText, 'shop'),
            community: getTextFromResource(getText, 'community'),
            store: getTextFromResource(getText, 'store'),
            offers: getTextFromResource(getText, 'offers'),
            home: getTextFromResource(getText, 'home'),
            me: getTextFromResource(getText, 'me'),
            myStore: getTextFromResource(getText, 'myStore')
        }),
        isShopYourStoreEnabledSelector,
        bottomNavHiddenSelector,
        showDynamicBottomNavSelector,
        (user, localization, isShopYourStoreEnabled, bottomNavHidden, showDynamicBottomNav) => {
            const isUserReady = user.isInitialized;

            return {
                user,
                isUserReady,
                isAnonymous: isUserReady && userUtils.isAnonymous(),
                localization,
                isShopYourStoreEnabled,
                bottomNavHidden,
                showDynamicBottomNav
            };
        }
    )
);
